// extracted by mini-css-extract-plugin
export default {"container":"Switch_container__NJyFw","switch":"Switch_switch__9kPdB"};